


import Vue from 'vue';
import $ from 'jquery';
import MenuComponent from '@/components/header/menu/menu.vue';
import {Location} from "vue-router";
import {localizedRoute} from "@/i18n/i18n.config";
import {RouteName} from "@/router";

window.addEventListener('scroll', () => {
    const scroll = $(window).scrollTop() || 0;
    if (scroll >= 50) {
        $(".header").addClass("header--sticky");
    } else {
        $(".header").removeClass("header--sticky");
    }
}, {passive: true});

export default Vue.extend({
    computed: {
        isOnHome(): boolean {
            return this.$route.name === RouteName.home;
        },
        homeRoute(): Location {
            return localizedRoute(RouteName.home);
        }
    },
    components: {
        'app-menu': MenuComponent
    }
});
